import React, { useEffect } from 'react';

import PasswordResetLayout from './PasswordResetLayout';

function PasswordResetSuccess() {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = '/signin';
    }, 8000);
  }, []);
  return (
    <PasswordResetLayout success>
      <div
        dangerouslySetInnerHTML={{
          __html: i18n.gettext(
            'Your password has been reset.<br/>You may now <a href="/signin">go ahead and sign in</a>...'
          ),
        }}
      />
    </PasswordResetLayout>
  );
}

export default PasswordResetSuccess;
